import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { SharedModule } from '@shared/shared.module';

/** Módulo partilhado por todas as páginas do template autodepoca */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    TranslocoModule,
    SharedModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    RouterModule,
    TranslocoModule,
    SharedModule,
  ],
})
export class AutodepocaSharedModule {}
